export default {
    allThanks: [],
    showThanks: {},
    thanksDeleteId: '',
    pagination: {},
    searchQuery: "&where=status@下書き,申請,公開",
}